import { createStyles, makeStyles } from '@material-ui/styles';
import { theme } from '../theme';
import { JupiterTheme } from './types';

const styles = (theme: JupiterTheme) =>
  createStyles({
    text: {
      color: theme.palette.grey[50],
    },
    textInput: {
      color: theme.palette.grey[50],
      '&:before': {
        borderColor: theme.palette.grey[300],
      },
      '&:hover:before': {
        borderColor: theme.palette.grey[200] + ' !important',
      },
    },
    disabled: {
      color: theme.palette.grey[200],
      '&$textFieldUnderline': {
        '&:before, &:after': {
          borderBottom: 'solid 1px' + theme.palette.navy[400],
        },
      },
    },
    textFieldUnderline: {
      color: theme.palette.primary.main,
    },
    helperText: {
      fontSize: '0.85rem',
      lineHeight: 1.3,
    },
    disabledHelpText: {
      '&&': {
        color: theme.palette.grey[300],
      },
    },
    textInputLabel: {
      color: theme.palette.grey[200],
    },
    textInputLabelFocused: {
      '&&': {
        color: theme.palette.primary.main,
      },
    },
    textInputLabelDisabled: {
      '&&': {
        color: theme.palette.grey[200],
      },
    },
    formLabel: {
      color: theme.palette.grey[50],
    },
    checkboxLabel: {
      color: theme.palette.grey[50],
    },
    checkboxLabelDisabled: {
      '&&': {
        color: theme.palette.grey[300],
      },
    },
    checkboxDisabled: {
      '& svg': {
        color: theme.palette.grey[300],
      },
    },
    spinnerCenter: {},
    bodyCell: {
      borderBottomColor: theme.palette.background.dark,
    },
    cellText: {
      color: theme.palette.grey[50],
    },
    tableBody: {
      backgroundColor: 'none',
    },
    rootRow: {
      '&$headRow': {
        background: theme.palette.background.main,
      },
    },
    headRow: {},
    rootCell: {
      '&$headCell': {
        color: theme.palette.grey[100],
      },
    },
    headCell: {
      borderBottomColor: theme.palette.background.dark,
    },
    link: {
      color: theme.palette.primary.main,
    },
    icon: {
      color: theme.palette.grey[200],
      '&:hover': {
        color: theme.palette.grey[50],
      },
    },
    containedButton: {
      backgroundColor: theme.palette.grey[50],
      '&:hover': {
        backgroundColor: theme.palette.grey[200],
      },
      '&:disabled': {
        backgroundColor: theme.palette.grey[300],
      },
    },
    outlinedButton: {
      color: theme.palette.grey[50],
      borderColor: theme.palette.grey[50],
      '&:hover': {
        color: theme.palette.grey[100],
        borderColor: theme.palette.grey[100],
      },
    },
  });

export default styles(theme as JupiterTheme);

const useDarkThemeStyles = makeStyles(styles);
export { useDarkThemeStyles };
